// Kunngjøringer — skrapet fra Brønnøysund, cachet i workerens D1. Samme amber-glass-stil
// som RollerCard/ExposureCard. Tom/utilgjengelig → diskret Enhetsregister-status.
import { Skeleton } from "@/components/ui/skeleton";
import { useKunngjoringer } from "../api/kunngjoringer";

interface KunngjoringerCardProps {
  orgnr: string;
}

const datoFmt = new Intl.DateTimeFormat("nb-NO", {
  day: "2-digit",
  month: "2-digit",
  year: "numeric",
});

function formatDato(dato: string | null): string {
  if (!dato) return "—";
  const t = Date.parse(dato);
  return Number.isNaN(t) ? dato : datoFmt.format(t);
}

export function KunngjoringerCard({ orgnr }: KunngjoringerCardProps) {
  const { data, isLoading } = useKunngjoringer(orgnr);
  const liste = data?.kunngjoringer ?? [];
  const tom = !data || data.available === false || liste.length === 0;

  return (
    <div className="glass mb-[18px] px-6 py-[22px]">
      <h2 className="m-0 mb-4 flex justify-between text-[13px] font-semibold text-[var(--sub)]">
        Kunngjøringer
        <span className="font-medium text-[var(--faint)]">Brønnøysund</span>
      </h2>

      {isLoading ? (
        <div className="space-y-2.5">
          {Array.from({ length: 3 }).map((_, i) => (
            <Skeleton key={i} className="h-6 bg-[rgba(120,60,10,0.1)]" />
          ))}
        </div>
      ) : tom ? (
        <p className="text-[13px] text-[var(--faint)]">
          Ingen kunngjøringer registrert · status fra Enhetsregisteret
        </p>
      ) : (
        <ul className="m-0 list-none p-0">
          {liste.map((k) => {
            const venstre = k.tekst ?? k.type ?? "Kunngjøring";
            const row = (
              <>
                <span className="font-semibold text-[var(--ink)]">{venstre}</span>
                <span className="text-[var(--sub)]">{formatDato(k.dato)}</span>
              </>
            );
            return (
              <li
                key={k.id}
                className="flex justify-between border-t border-[rgba(120,60,10,0.12)] py-[11px] first:border-t-0"
              >
                {k.lenke ? (
                  <a
                    href={k.lenke}
                    target="_blank"
                    rel="noopener"
                    className="flex w-full justify-between"
                  >
                    {row}
                  </a>
                ) : (
                  row
                )}
              </li>
            );
          })}
        </ul>
      )}
    </div>
  );
}
